module.exports = __webpack_public_path__ + "assets/home-folder-library.9ed3594f.svg";